import React from 'react';

const SendAgain = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21 1.5H3A2.503 2.503 0 0 0 .5 4v11A2.503 2.503 0 0 0 3 17.5h1v3.978a1.016 1.016 0 0 0 .634.95.98.98 0 0 0 1.08-.236l4.5-4.692H21a2.503 2.503 0 0 0 2.5-2.5V4A2.503 2.503 0 0 0 21 1.5zM22.5 15a1.502 1.502 0 0 1-1.5 1.5H10a.499.499 0 0 0-.36.154L5 21.478V17a.5.5 0 0 0-.5-.5H3A1.502 1.502 0 0 1 1.5 15V4A1.502 1.502 0 0 1 3 2.5h18A1.502 1.502 0 0 1 22.5 4v11z'
        fill='#000'
      />
      <path
        d='M4.538 6.309A.5.5 0 0 0 5 7h5a.5.5 0 0 0 0-1H5a.5.5 0 0 0-.462.309zM15.462 12.691A.5.5 0 0 0 15 12H5a.5.5 0 0 0 0 1h10a.5.5 0 0 0 .462-.309zM17.462 9.691A.5.5 0 0 0 17 9H5a.5.5 0 1 0 0 1h12a.5.5 0 0 0 .462-.309z'
        fill='#000'
      />
    </svg>
  );
};

export default SendAgain;
